import type { ReportDialogStep } from '@/reporting/util';
import { CUSTOM_REPORT_BUILDER_SET_ACTIVE_DIALOG } from '@/store/action-types';

export default function setActiveDialog(dialog?: ReportDialogStep) {
  return {
    type: CUSTOM_REPORT_BUILDER_SET_ACTIVE_DIALOG,
    payload: dialog,
  };
}
